module.exports = "<div class=\"content-padding\" [innerHTML]=\"page?.content?.rendered\">\n</div>"